import React from 'react';
import { TrendingUp, Shield, Zap, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
export function InvestorSection() {
  // Define the gradient for icons
  const iconGradient = <linearGradient id="investorIconGradient" x1="0%" y1="0%" x2="100%" y2="0%" data-id="element-155">
      <stop offset="0%" stopColor="#gray-900" data-id="element-156" />
      <stop offset="100%" stopColor="#gray-700" data-id="element-157" />
    </linearGradient>;
  // Dark mode gradient for icons
  const darkIconGradient = <linearGradient id="investorDarkIconGradient" x1="0%" y1="0%" x2="100%" y2="0%" data-id="element-158">
      <stop offset="0%" stopColor="white" data-id="element-159" />
      <stop offset="100%" stopColor="#gray-300" data-id="element-160" />
    </linearGradient>;
  // Custom icon component that applies the gradient
  const GradientIcon = ({
    icon: Icon
  }) => <div className="relative" data-id="element-161">
      <svg width="0" height="0" className="absolute" data-id="element-162">
        {iconGradient}
        {darkIconGradient}
      </svg>
      <Icon size={24} className="dark:stroke-[url(#investorDarkIconGradient)] stroke-[url(#investorIconGradient)]" strokeWidth={2} data-id="element-163" />
    </div>;
  return <section id="investors" className="py-24 relative overflow-hidden" data-id="element-164">
      {/* Decorative elements */}
      <div className="absolute -top-[20%] -left-[10%] w-[70%] h-[70%] rounded-full bg-[#BBDDFF]/10 blur-3xl" data-id="element-165"></div>
      <div className="absolute -bottom-[20%] -right-[10%] w-[70%] h-[70%] rounded-full bg-[#C85A15]/5 blur-3xl" data-id="element-166"></div>
      <div className="container mx-auto px-6 relative z-10" data-id="element-167">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-168">
          <div data-id="element-169">
            <div className="inline-block mb-4 px-4 py-1 rounded-full bg-gradient-to-r from-[#BBDDFF]/10 to-[#C85A15]/10 backdrop-blur-sm border border-white/10" data-id="element-170">
              <span className="text-sm font-medium" data-id="element-171">For Investors</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-172">
              <span className="bg-gradient-to-r from-[#BBDDFF] to-[#C85A15] bg-clip-text text-transparent" data-id="element-173">
                The infrastructure powering digital health's future
              </span>
            </h2>
            <p className="text-lg text-gray-600 dark:text-gray-300 mb-8" data-id="element-174">
              JoinOmu is positioned to revolutionize healthcare delivery by
              connecting patient medication and tracking data points and making
              them available to providers and health technology platforms to
              optimize care. Our in-house technology platform, dedicated
              provider network, and scalable business model is ready to expand
              into additional treatment areas and poised to take advantage of a
              healthcare future powered by AI.
            </p>
            <div className="space-y-6 mb-8" data-id="element-175">
              <div className="flex" data-id="element-176">
                <div className="w-12 h-12 rounded-full bg-gradient-to-r from-gray-100 to-gray-200 dark:from-gray-800 dark:to-gray-700 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-177">
                  <GradientIcon icon={TrendingUp} data-id="element-178" />
                </div>
                <div data-id="element-179">
                  <h3 className="text-lg font-semibold mb-1" data-id="element-180">
                    Experienced Leadership
                  </h3>
                  <p className="text-gray-600 dark:text-gray-300" data-id="element-181">
                    Leadership with digital health experience across multiple
                    companies and has helped build and scale a $100M+ ARR
                    digital health company previously, pre-Series A.
                  </p>
                </div>
              </div>
              <div className="flex" data-id="element-182">
                <div className="w-12 h-12 rounded-full bg-gradient-to-r from-gray-100 to-gray-200 dark:from-gray-800 dark:to-gray-700 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-183">
                  <GradientIcon icon={Shield} data-id="element-184" />
                </div>
                <div data-id="element-185">
                  <h3 className="text-lg font-semibold mb-1" data-id="element-186">
                    Enterprise-Grade Security
                  </h3>
                  <p className="text-gray-600 dark:text-gray-300" data-id="element-187">
                    HIPAA-compliant infrastructure with sophisticated data
                    protection with the goal to exceeds industry standards.
                  </p>
                </div>
              </div>
              <div className="flex" data-id="element-188">
                <div className="w-12 h-12 rounded-full bg-gradient-to-r from-gray-100 to-gray-200 dark:from-gray-800 dark:to-gray-700 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-189">
                  <GradientIcon icon={Zap} data-id="element-190" />
                </div>
                <div data-id="element-191">
                  <h3 className="text-lg font-semibold mb-1" data-id="element-192">
                    Expansion Ready
                  </h3>
                  <p className="text-gray-600 dark:text-gray-300" data-id="element-193">
                    Scalable platform architecture designed to rapidly deploy
                    into additional treatment areas and establish partnerships
                    with the companies bringing AI into Healthcare.
                  </p>
                </div>
              </div>
            </div>
            <Link to="/investors" className="inline-flex items-center bg-gradient-to-r from-[#BBDDFF] to-[#C85A15] text-white font-medium py-3 px-6 rounded-full hover:shadow-lg transition-all group" data-id="element-194">
              Connect with our team
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={18} data-id="element-195" />
            </Link>
          </div>
          <div className="relative" data-id="element-196">
            <div className="absolute inset-0 bg-gradient-to-br from-[#BBDDFF]/20 to-[#C85A15]/20 rounded-3xl blur-xl" data-id="element-197"></div>
            <div className="relative bg-white dark:bg-gray-800/80 backdrop-blur-sm rounded-2xl p-8 shadow-xl border border-white/20 dark:border-gray-700/30" data-id="element-198">
              <div className="space-y-6" data-id="element-199">
                <div className="hidden bg-gray-50 dark:bg-gray-700/30 p-6 rounded-xl" data-id="element-200">
                  <h3 className="text-xl font-bold mb-4" data-id="element-201">Growth Metrics</h3>
                  <div className="space-y-4" data-id="element-202">
                    <div data-id="element-203">
                      <div className="flex justify-between mb-1" data-id="element-204">
                        <span className="text-sm text-gray-600 dark:text-gray-300" data-id="element-205">
                          Patient Acquisition
                        </span>
                        <span className="text-sm font-medium" data-id="element-206">+187%</span>
                      </div>
                      <div className="w-full h-2 bg-gray-200 dark:bg-gray-600 rounded-full overflow-hidden" data-id="element-207">
                        <div className="h-full bg-gradient-to-r from-[#BBDDFF] to-[#C85A15] rounded-full" style={{
                        width: '87%'
                      }} data-id="element-208"></div>
                      </div>
                    </div>
                    <div data-id="element-209">
                      <div className="flex justify-between mb-1" data-id="element-210">
                        <span className="text-sm text-gray-600 dark:text-gray-300" data-id="element-211">
                          Provider Network
                        </span>
                        <span className="text-sm font-medium" data-id="element-212">+93%</span>
                      </div>
                      <div className="w-full h-2 bg-gray-200 dark:bg-gray-600 rounded-full overflow-hidden" data-id="element-213">
                        <div className="h-full bg-gradient-to-r from-[#BBDDFF] to-[#C85A15] rounded-full" style={{
                        width: '63%'
                      }} data-id="element-214"></div>
                      </div>
                    </div>
                    <div data-id="element-215">
                      <div className="flex justify-between mb-1" data-id="element-216">
                        <span className="text-sm text-gray-600 dark:text-gray-300" data-id="element-217">
                          Revenue Growth
                        </span>
                        <span className="text-sm font-medium" data-id="element-218">+215%</span>
                      </div>
                      <div className="w-full h-2 bg-gray-200 dark:bg-gray-600 rounded-full overflow-hidden" data-id="element-219">
                        <div className="h-full bg-gradient-to-r from-[#BBDDFF] to-[#C85A15] rounded-full" style={{
                        width: '95%'
                      }} data-id="element-220"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bg-gray-50 dark:bg-gray-700/30 p-6 rounded-xl" data-id="element-221">
                  <h3 className="text-xl font-bold mb-4" data-id="element-222">Market Opportunity</h3>
                  <div className="grid grid-cols-2 gap-4" data-id="element-223">
                    <div className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow-sm" data-id="element-224">
                      <div className="text-3xl font-bold bg-gradient-to-r from-[#BBDDFF] to-[#C85A15] bg-clip-text text-transparent" data-id="element-225">
                        $78B
                      </div>
                      <div className="text-sm text-gray-600 dark:text-gray-300" data-id="element-226">
                        Weight Management Market (8.8% CAGR)
                      </div>
                    </div>
                    <div className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow-sm" data-id="element-227">
                      <div className="text-3xl font-bold bg-gradient-to-r from-[#BBDDFF] to-[#C85A15] bg-clip-text text-transparent" data-id="element-228">
                        $19B
                      </div>
                      <div className="text-sm text-gray-600 dark:text-gray-300" data-id="element-229">
                        Men's Health Market (6.5% CAGR)
                      </div>
                    </div>
                    <div className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow-sm" data-id="element-230">
                      <div className="text-3xl font-bold bg-gradient-to-r from-[#BBDDFF] to-[#C85A15] bg-clip-text text-transparent" data-id="element-231">
                        $97B
                      </div>
                      <div className="text-sm text-gray-600 dark:text-gray-300" data-id="element-232">
                        Combined Market Opportunity
                      </div>
                    </div>
                    <div className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow-sm" data-id="element-233">
                      <div className="text-3xl font-bold bg-gradient-to-r from-[#BBDDFF] to-[#C85A15] bg-clip-text text-transparent" data-id="element-234">
                        5+
                      </div>
                      <div className="text-sm text-gray-600 dark:text-gray-300" data-id="element-235">
                        Expansion Treatment Areas
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}